import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ICardState, ICianCard } from 'shared/createCard/types/cianCard';

const initialState: ICardState = {
  profile: null,
};

/* istanbul ignore next */
const cianCardSlice = createSlice({
  initialState,
  name: 'cianCard',
  reducers: {
    setLink: (state, action: PayloadAction<string>) => {
      if (state.profile) {
        state.profile.uuid = action.payload;
      }
    },
    setProfile: (state, action: PayloadAction<ICianCard>) => {
      state.profile = action.payload;
    },
  },
});

export const {
  reducer: cianCardReducer,
  actions: { setLink, setProfile },
} = cianCardSlice;
